import { IconName } from "@elearning-platform/ui";

import { ReactComponent as ModuleIcon } from "./../../images/knowledgeBase.svg";

export const Config = {
  moduleName: "knowledgeBaseV2",
  dependencies: [],
  label: "competence.app.knowledgeBaseV2.label",
  Icon: ModuleIcon,
  urls: ["/lekcje"],
  routeName: "api_learning_list",
  routes: {},
  options: {},
  theme: {},
  modernIconName: IconName.PageKnowledgeBase,
  ignoreModuleFromGlobalState: true,
};
